import { render, staticRenderFns } from "./ModalLogs.vue?vue&type=template&id=2ed59ad4"
import script from "./ModalLogs.vue?vue&type=script&lang=js"
export * from "./ModalLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports